module.exports = __webpack_public_path__ + "static/benefits-5d16ee269574c2a330ff92159f0051d2.png";